import FJAIVideoGeneratorLeftContainer from "./FJAIVideoGeneratorLeft/container/FJAIVideoGeneratorLeftContainer.jsx";
import FJAIVideoGeneratorRightContainer from "./FJAIVideoGeneratorRight/container/FJAIVideoGeneratorRightContainer.jsx";

function FJAIVideoGenerator() {


    return (
        <>
            <FJAIVideoGeneratorLeftContainer />
            <FJAIVideoGeneratorRightContainer />
        </>
    );
}

export default FJAIVideoGenerator;
